
import isStringOrStringArray from '@/utils/isStringOrStringArray';

export default {
  name: 'BasePackageTagCheckbox',

  componentName: 'BasePackageTagCheckbox',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    tagList: function tagList() {
      var _this = this;

      return this.$store.state.tags.basePackageTagList.map(function (item) {
        return {
          value: isStringOrStringArray(_this.formValue[_this.config.prop]) ? String(item.id) : Number(item.id), // 兼容传入参数的类型
          label: item.name,
          border: true // 保证UI统一性
        };
      });
    }
  },

  mounted: function mounted() {
    if (this.tagList && !this.tagList.length) {
      this.$store.dispatch('GetBasePackageTagList');
    }
  }
};